import React from "react";
import { Modal, Form, Input, InputNumber, message } from "antd";
import api from "../api";

const CreateTipoCajaModal = ({ open, onCancel, onSuccess }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await api.post("/tiposCajas/agregar", values);
      message.success("Tipo de caja creado correctamente");
      form.resetFields();
      onSuccess();
    } catch (error) {
      message.error("Error al crear tipo de caja");
    }
  };

  return (
    <Modal
      title="Nuevo Tipo de Caja"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: "Por favor ingresa el nombre de la caja" }]}
        >
          <Input placeholder="Caja pequeña, mediana..." />
        </Form.Item>

        <Form.Item
          name="pesoKg"
          label="Peso (Kg)"
          rules={[{ required: true, message: "Por favor ingresa el peso" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} placeholder="10.5" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateTipoCajaModal;
